import { useEffect, useState } from 'react';
import { Keyboard } from 'react-native';

/** Keyboard-height tracking αντί για KeyboardAvoidingView (behavior 'height'
 * προκαλεί double-resize/flicker σε Android modals — layout↔keyboard geometry
 * feedback loop). Χρησιμοποίησε το ύψος για να μετατοπίσεις το modal/sheet
 * προς τα πάνω αντί να το αφήσεις να «τρέμει». */
export function useKeyboardHeight(): number {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const showSub = Keyboard.addListener('keyboardDidShow', (e) => setHeight(e.endCoordinates.height));
    const hideSub = Keyboard.addListener('keyboardDidHide', () => setHeight(0));
    return () => {
      showSub.remove();
      hideSub.remove();
    };
  }, []);
  return height;
}
